import * as React from "react";

import { getPointKey } from "./ImageAnnotatorQuestion";
import { PointCircle } from "./PointCircle";
import { Point } from "./models";

export const PointCircles: React.FunctionComponent<{points: Point[]; numberPoints?: boolean}> = props => {
    return (
        <>
            {props.points.map((p, index) =>
                <PointCircle label={index + 1} point={p} key={getPointKey(p)} />
            )}
        </>
    );
};
